module.exports = __webpack_public_path__ + "media/Components/fonts/Cinzel-7eaa74b340191c6106277b0068cf39f9.ttf";